import type {
  ObservationUpdateOptions,
  ObservationUpdateVariables,
} from "./observation-update.type";
import type { ObservationEntity } from "../observation.type";

import { useUpdate } from "@/hooks/queries";

export const useObservationUpdate = (
  observationId: number,
  options?: ObservationUpdateOptions
) => {
  const invalidateKeys = options?.invalidateKeys;
  const { mutate, mutateAsync, ...queryResult } = useUpdate<
    ObservationEntity,
    ObservationUpdateVariables
  >("observations", observationId, { invalidateKeys });

  const updateObservation = (variables: ObservationUpdateVariables) => {
    mutate(variables);
  };

  const updateObservationAsync = async (
    variables: ObservationUpdateVariables
  ) => {
    const response = await mutateAsync(variables);
    const newObservation = response.data.data;
    return newObservation;
  };

  return {
    ...queryResult,
    updateObservation,
    updateObservationAsync,
  };
};
